var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9564 3.5C2.8434 3.50002 2.73294 3.53355 2.63899 3.59634C2.54504 3.65914 2.47181 3.74838 2.42857 3.85278C2.38533 3.95718 2.37401 4.07206 2.39605 4.1829C2.41809 4.29373 2.4725 4.39554 2.55239 4.47546L5.40962 7.33269C5.51678 7.43982 5.66211 7.5 5.81363 7.5C5.96516 7.5 6.11048 7.43982 6.21765 7.33269L9.07488 4.47546C9.15477 4.39554 9.20917 4.29373 9.23121 4.1829C9.25325 4.07206 9.24194 3.95718 9.1987 3.85278C9.15545 3.74838 9.08223 3.65914 8.98828 3.59634C8.89433 3.53355 8.78387 3.50002 8.67086 3.5H2.9564Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionArrowDown);
export default __webpack_public_path__ + "static/media/AccordionArrowDown.bb67d485bd4062b356da29e10581ba55.svg";
export { ForwardRef as ReactComponent };